module.exports = __webpack_public_path__ + "img/iboard-illustration.8b49cdad.png";